/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ScholarshipfileapprovalFilesApprovalStatus202,
  PutApiV1ScholarshipfileapprovalFilesApprovalStatus400,
  PutApiV1ScholarshipfileapprovalFilesApprovalStatus401,
  PutApiV1ScholarshipfileapprovalFilesApprovalStatus500,
  PutApiV1ScholarshipfileapprovalFilesApprovalStatusMutationRequest,
  PutApiV1ScholarshipfileapprovalFilesApprovalStatusMutationResponse,
} from "../../types/scholarshipTypeFileApprovalController/PutApiV1ScholarshipfileapprovalFilesApprovalStatus.ts";
import { changeScholarshipFileApprovalStatusRequestViewModelSchema } from "../changeScholarshipFileApprovalStatusRequestViewModelSchema.ts";
import { changeScholarshipFileApprovalStatusResultViewModelSchema } from "../changeScholarshipFileApprovalStatusResultViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ScholarshipfileapprovalFilesApprovalStatus202Schema =
  z.lazy(
    () => changeScholarshipFileApprovalStatusResultViewModelSchema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ScholarshipfileapprovalFilesApprovalStatus400Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ScholarshipfileapprovalFilesApprovalStatus401Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ScholarshipfileapprovalFilesApprovalStatus500Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatus500>;

export const putApiV1ScholarshipfileapprovalFilesApprovalStatusMutationRequestSchema =
  z.lazy(
    () => changeScholarshipFileApprovalStatusRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatusMutationRequest>;

export const putApiV1ScholarshipfileapprovalFilesApprovalStatusMutationResponseSchema =
  z.lazy(
    () => putApiV1ScholarshipfileapprovalFilesApprovalStatus202Schema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalFilesApprovalStatusMutationResponse>;
